"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemFile = exports.MemPackage = exports.MsgAddPackage = exports.MsgCall = exports.protobufPackage = void 0;
/* eslint-disable */
var long_1 = __importDefault(require("long"));
var minimal_1 = __importDefault(require("protobufjs/minimal"));
exports.protobufPackage = 'gno.vm';
function createBaseMsgCall() {
    return { caller: '', send: '', pkg_path: '', func: '', args: null };
}
exports.MsgCall = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.default.Writer.create(); }
        if (message.caller !== '') {
            writer.uint32(10).string(message.caller);
        }
        if (message.send !== '') {
            writer.uint32(18).string(message.send);
        }
        if (message.pkg_path !== '') {
            writer.uint32(26).string(message.pkg_path);
        }
        if (message.func !== '') {
            writer.uint32(34).string(message.func);
        }
        if (message.args) {
            for (var _i = 0, _a = message.args; _i < _a.length; _i++) {
                var v = _a[_i];
                writer.uint32(42).string(v);
            }
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgCall();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.caller = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.send = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.pkg_path = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.func = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    if (!message.args) {
                        message.args = [];
                    }
                    message.args.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            caller: isSet(object.caller) ? String(object.caller) : '',
            send: isSet(object.send) ? String(object.send) : '',
            pkg_path: isSet(object.pkg_path) ? String(object.pkg_path) : '',
            func: isSet(object.func) ? String(object.func) : '',
            args: Array.isArray(object === null || object === void 0 ? void 0 : object.args)
                ? object.args.map(function (e) { return String(e); })
                : null,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if (message.caller !== '') {
            obj.caller = message.caller;
        }
        if (message.send !== '') {
            obj.send = message.send;
        }
        if (message.pkg_path !== '') {
            obj.pkg_path = message.pkg_path;
        }
        if (message.func !== '') {
            obj.func = message.func;
        }
        if ((_a = message.args) === null || _a === void 0 ? void 0 : _a.length) {
            obj.args = message.args;
        }
        else {
            obj.args = null;
        }
        return obj;
    },
    create: function (base) {
        return exports.MsgCall.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e;
        var message = createBaseMsgCall();
        message.caller = (_a = object.caller) !== null && _a !== void 0 ? _a : '';
        message.send = (_b = object.send) !== null && _b !== void 0 ? _b : '';
        message.pkg_path = (_c = object.pkg_path) !== null && _c !== void 0 ? _c : '';
        message.func = (_d = object.func) !== null && _d !== void 0 ? _d : '';
        message.args = ((_e = object.args) === null || _e === void 0 ? void 0 : _e.map(function (e) { return e; })) || null;
        return message;
    },
};
function createBaseMsgAddPackage() {
    return { creator: '', package: undefined, deposit: '' };
}
exports.MsgAddPackage = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.default.Writer.create(); }
        if (message.creator !== '') {
            writer.uint32(10).string(message.creator);
        }
        if (message.package !== undefined) {
            exports.MemPackage.encode(message.package, writer.uint32(18).fork()).ldelim();
        }
        if (message.deposit !== '') {
            writer.uint32(26).string(message.deposit);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgAddPackage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.package = exports.MemPackage.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.deposit = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            creator: isSet(object.creator) ? String(object.creator) : '',
            package: isSet(object.package)
                ? exports.MemPackage.fromJSON(object.package)
                : undefined,
            deposit: isSet(object.deposit) ? String(object.deposit) : '',
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.creator !== '') {
            obj.creator = message.creator;
        }
        if (message.package !== undefined) {
            obj.package = exports.MemPackage.toJSON(message.package);
        }
        if (message.deposit !== '') {
            obj.deposit = message.deposit;
        }
        return obj;
    },
    create: function (base) {
        return exports.MsgAddPackage.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseMsgAddPackage();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : '';
        message.package =
            object.package !== undefined && object.package !== null
                ? exports.MemPackage.fromPartial(object.package)
                : undefined;
        message.deposit = (_b = object.deposit) !== null && _b !== void 0 ? _b : '';
        return message;
    },
};
function createBaseMemPackage() {
    return { name: '', path: '', files: [] };
}
exports.MemPackage = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.default.Writer.create(); }
        if (message.name !== '') {
            writer.uint32(10).string(message.name);
        }
        if (message.path !== '') {
            writer.uint32(18).string(message.path);
        }
        for (var _i = 0, _a = message.files; _i < _a.length; _i++) {
            var v = _a[_i];
            exports.MemFile.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMemPackage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.path = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.files.push(exports.MemFile.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            name: isSet(object.name) ? String(object.name) : '',
            path: isSet(object.path) ? String(object.path) : '',
            files: Array.isArray(object === null || object === void 0 ? void 0 : object.files)
                ? object.files.map(function (e) { return exports.MemFile.fromJSON(e); })
                : [],
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.path !== '') {
            obj.path = message.path;
        }
        if ((_a = message.files) === null || _a === void 0 ? void 0 : _a.length) {
            obj.files = message.files.map(function (e) { return exports.MemFile.toJSON(e); });
        }
        return obj;
    },
    create: function (base) {
        return exports.MemPackage.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseMemPackage();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : '';
        message.path = (_b = object.path) !== null && _b !== void 0 ? _b : '';
        message.files = ((_c = object.files) === null || _c === void 0 ? void 0 : _c.map(function (e) { return exports.MemFile.fromPartial(e); })) || [];
        return message;
    },
};
function createBaseMemFile() {
    return { name: '', body: '' };
}
exports.MemFile = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.default.Writer.create(); }
        if (message.name !== '') {
            writer.uint32(10).string(message.name);
        }
        if (message.body !== '') {
            writer.uint32(18).string(message.body);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMemFile();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.body = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            name: isSet(object.name) ? String(object.name) : '',
            body: isSet(object.body) ? String(object.body) : '',
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.body !== '') {
            obj.body = message.body;
        }
        return obj;
    },
    create: function (base) {
        return exports.MemFile.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseMemFile();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : '';
        message.body = (_b = object.body) !== null && _b !== void 0 ? _b : '';
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
